import React from 'react';
import { SectionWrapper, SectionTitle, FuelGrid, FuelCard, FuelValueWrapper, FuelUnitLabel } from './FuelEconomySection.style';
import type { FuelEconomySectionProps } from '../../types/VehicleSectionProps';
import { Heading, Text } from '@makemydeal/dr-ui-bricks-components';

export const FuelEconomySection: React.FC<FuelEconomySectionProps> = ({ fuelEconomy }) => {
    const { city, highway, combined } = fuelEconomy;

    return (
        <SectionWrapper data-testid="fuel-economy-section">
            <SectionTitle>
                <Heading level={6} weight="bold">
                    EPA Estimated MPG
                </Heading>
            </SectionTitle>

            <FuelGrid>
                <FuelCard data-testid="fuel-city">
                    <Text size="base" weight="bold">
                        {city.label}
                    </Text>
                    <FuelValueWrapper>
                        <Text size="xlarge" weight="bold" data-testid="fuel-city-value">
                            {city.value}
                        </Text>
                        <FuelUnitLabel size="base" weight="regular">
                            {city.unit}
                        </FuelUnitLabel>
                    </FuelValueWrapper>
                </FuelCard>

                <FuelCard data-testid="fuel-highway">
                    <Text size="base" weight="bold">
                        {highway.label}
                    </Text>
                    <FuelValueWrapper>
                        <Text size="xlarge" weight="bold" data-testid="fuel-highway-value">
                            {highway.value}
                        </Text>
                        <FuelUnitLabel size="base" weight="regular">
                            {highway.unit}
                        </FuelUnitLabel>
                    </FuelValueWrapper>
                </FuelCard>

                <FuelCard data-testid="fuel-combined">
                    <Text size="base" weight="bold">
                        {combined.label}
                    </Text>
                    <FuelValueWrapper>
                        <Text size="xlarge" weight="bold" data-testid="fuel-combined-value">
                            {combined.value}
                        </Text>
                        <FuelUnitLabel size="base" weight="regular">
                            {combined.unit}
                        </FuelUnitLabel>
                    </FuelValueWrapper>
                </FuelCard>
            </FuelGrid>
        </SectionWrapper>
    );
};
